/**
 * Config-driven renderers for DMT-style mint collections.
 *
 * To add a new DMT collection, append an entry below keyed by the OW slug.
 *
 * Two strategies:
 *   - `block-renderer`: image URL = `${baseUrl}/${blk}` (HTML renderer service that takes a DMT block number).
 *   - `static-image`:   image URL = `urlTemplate` with `{id}` replaced by the inscription id (prerendered host).
 */
export type DmtRendererConfig =
	| { type: 'block-renderer'; baseUrl: string }
	| { type: 'static-image'; urlTemplate: string }

export const DMT_RENDERERS: Record<string, DmtRendererConfig> = {
	'dmt-gibnat': {
		type: 'static-image',
		urlTemplate:
			'https://trac-systems.github.io/gibnat-satflow-assets/images/{id}.png',
	},
}


export function extractDmtBlk(inscription: any): string {
	return (
		inscription?.meta?.name?.replace?.(/[^0-9]/g, '') ||
		inscription?.escrow?.name?.replace?.(/[^0-9]/g, '') ||
		inscription?.meta?.attributes?.find?.((a: any) => a.trait_type === 'blk')?.value ||
		inscription?.meta?.attributes?.find?.((a: any) => a.trait_type === 'DMT Block')?.value ||
		inscription?.name?.replace?.(/[^0-9]/g, '') ||
		inscription?.blk ||
		''
	)
}

export function getDmtImageUrl(slug: string, inscription: { id: string }, blk: string): string | null {
	const config = DMT_RENDERERS[slug]
	if (!config) return null
	if (config.type === 'static-image') {
		return config.urlTemplate.replace('{id}', inscription.id)
	}
	if (config.type === 'block-renderer') {
		if (!blk) return null
		return `${config.baseUrl}/${blk}`
	}
	return null
}
